/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Balance_Short_SettledInputs */

const en_balance_short_settled = /** @type {(inputs: Balance_Short_SettledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settled`)
};

const he_balance_short_settled = /** @type {(inputs: Balance_Short_SettledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סגור`)
};

/**
* | output |
* | --- |
* | "Settled" |
*
* @param {Balance_Short_SettledInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const balance_short_settled = /** @type {((inputs?: Balance_Short_SettledInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Balance_Short_SettledInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_balance_short_settled(inputs)
	return he_balance_short_settled(inputs)
});